import React, { useState } from 'react'

import { Link } from 'react-router-dom'

import {
  QuestionCircleTwoTone,
  CheckCircleTwoTone,
  EditOutlined
} from '@ant-design/icons'

import {
  CATLOG_FORMAT_XTM,
  CATLOG_FORMAT_SALESFORCE,
  VENDOR_STATUS_CONFIRMED,
  TASK_STATUS,
} from '../../../../config/const'

import {
  LAYOUT_MANAGER_TASK_RECEIVABLE_SALESFORCE,
  LAYOUT_MANAGER_TASK_RECEIVABLE_XTM
} from '../../../../layouts/manager/navigation'

import { EditableSelectValue } from '../../../../core/components/widget'
import { Table, Space, Button, Divider, Popconfirm } from 'antd'

import Settings from '../../../../components/job/task/settings'

import DateTimeTask from '../../../../components/job/task/status/datetime'

const Tasks = (props) => {
  const {

    // Permisions
    allowUpdateStatus,
    isModalActive,
    actionLoading,
    allowEdit,

    // Data
    tasks,

    // Actions
    updateTaskStatus,
    removeTask,

    // Modals
    onModalEdit,
    onModalAssign
  } = props

  const expandedRowRender = (record) => {
    const columns = [
      { title: '', dataIndex: '', key: '' },
      { title: 'Count', dataIndex: 'count', key: 'count', align: 'right', width: 50 },
      {
        title: 'Type',
        dataIndex: 'catlogValue',
        key: 'catlogValue',
        width: 300,
        render: (catvalue) => <span>{catvalue.name} </span>
      },
    ]

    return (
      <Table
        rowKey={(row) => row.id}
        columns={columns}
        dataSource={(record.receivables || []).filter((item) => item.subtotalValue > 0)}
        pagination={false}
        title={() => <Settings task={record} />}
      />
    )
  }

  const columns = () => {
    const __columns = [
      { title: '#', dataIndex: 'code', key: 'order', width: 50 },
      { title: 'Service', dataIndex: 'name', key: 'name' },
      {
        title: 'Category',
        dataIndex: 'serviceCategory',
        key: 'category',
        render: (category, record) => {
          if (category) {
            return <>{category?.name}</>
          } else {
            if (record.serviceCategoryId) {
              return <>{record.serviceCategoryId ? record.serviceCategoryId.name : '' }</>
            }
            return null
          }
        }
      },
      {
        title: 'Language(s)',
        dataIndex: 'languageType',
        key: 'languageType',
        render: (type, record) => {
          if (type === 'Single') {
            if (record.languageFamily === 'LTR' || record.languageFamily === 'RTL') {
              return <>{record.languageFamily}</>
            }
            return <>{record.language ? record.language.name : ''}</>
          } else {
            return <>{record.languagePair ? record.languagePair.name : ''}</>
          }
        }
      },
      {
        title: 'Unit',
        dataIndex: 'baseUnit',
        key: 'unit',
        render: (unit, record) => {
          if (unit) {
            if (record.isWord) {
              return <>{record.effectiveWordCount} WC</>
            } else {
              return (
                <>
                  {record.baseUnitAmount} {unit ? unit.name : ''}
                </>
              )
            }
          }
        }
      },
      {
        title: 'Vendor',
        dataIndex: 'vendor',
        key: 'vendor',
        render: (vendor, record) => {
          return (
            <Space split={<Divider type='vertical' />}>
              {record.vendorStatus === VENDOR_STATUS_CONFIRMED
                ? (<CheckCircleTwoTone twoToneColor='#52c41a' />)
                : (<QuestionCircleTwoTone />)}

              <Button
                size='small'
                type='dashed'
                onClick={() => onModalAssign(record)}
                disabled={isModalActive || actionLoading || !allowEdit}
              >
                {vendor ? vendor.name : '(Unassigned)'} <EditOutlined />
              </Button>
            </Space>
          )
        }
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        render: (value, record) => {
          return (
            <EditableSelectValue
              disableClear
              allowEdit={allowUpdateStatus}
              defaultValue={value}
              onChange={(st) => updateTaskStatus({ taskId: record.id, form: { status: st } })}
              defaultName={value}
              options={TASK_STATUS}
              disabled={actionLoading}
            />
          )
        }
      },
      {
        title: 'Deadline',
        dataIndex: 'deadlineAt',
        key: 'deadlineAt',
        render: (deadlineAt, record) => <DateTimeTask value={deadlineAt} status={record.status} />
      },
      {
        title: 'Free',
        dataIndex: 'isFree',
        key: 'isFree',
        width: 50,
        render: (free) => (free ? <CheckCircleTwoTone twoToneColor='#52c41a' /> : <></>)
      }
    ]

    /* completar condición */
    if (allowEdit) {
      __columns.push({
        title: 'Action',
        key: 'operation',
        align: 'center',
        render: (record) => {
          if (allowEdit) {
            return (
              <Space split={<Divider type='vertical' />}>
                <Button
                  size='small'
                  type='link'
                  block
                  onClick={() => onModalEdit(record)}
                  disabled={isModalActive || actionLoading}
                >
                  Edit
                </Button>
                {record.catlog && record.catlog.id === CATLOG_FORMAT_XTM && (
                  <Link to={LAYOUT_MANAGER_TASK_RECEIVABLE_XTM(record.id)}>Words</Link>
                )}

                {record.catlog && record.catlog.id === CATLOG_FORMAT_SALESFORCE && (
                  <Link to={LAYOUT_MANAGER_TASK_RECEIVABLE_SALESFORCE(record.id)}>Words</Link>
                )}

                <Popconfirm
                  title='Are you sure?'
                  onConfirm={() => removeTask(record.id)}
                  okText='Yes'
                  cancelText='No'
                  disabled={actionLoading}
                >
                  <Button type='link' disabled={actionLoading}>
                    Delete
                  </Button>
                </Popconfirm>
              </Space>
            )
          }
        }
      })
    }

    return __columns
  }

  return (
    <Table
      size='small'
      className='components-table-demo-nested'
      columns={columns()}
      expandable={{
        expandedRowRender: (record) => expandedRowRender(record),
        rowExpandable: (record) => record.catlog
      }}
      dataSource={tasks}
      rowKey={(row) => row.id}
      pagination={false}
    />
  )
}

export default Tasks
